/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WhiteWasteEntry } from '../../models/white-waste-entry';

export interface AddWhiteWasteToMountedMaterial$Params {
  mountedMaterialId: number;
      body: WhiteWasteEntry
}

export function addWhiteWasteToMountedMaterial(http: HttpClient, rootUrl: string, params: AddWhiteWasteToMountedMaterial$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addWhiteWasteToMountedMaterial.PATH, 'post');
  if (params) {
    rb.path('mountedMaterialId', params.mountedMaterialId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addWhiteWasteToMountedMaterial.PATH = '/api/v1/PrimaryMaterial/{mountedMaterialId}/AddWhiteWasteToMountedMaterial';
